// extracted by mini-css-extract-plugin
export default {"wrapper":"ThreePartyDeviceDocking_wrapper__I5EUr","btnBlank":"ThreePartyDeviceDocking_btnBlank__mfRDz"};